import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full items-center justify-between gap-4" }

import Message from 'primevue/message';
import Button from 'primevue/button';

import { useCurrentCalculation } from '../composables/useCurrentCalculation';
import { useSaveCalculation } from '../composables/useSaveCalculation';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationOutdatedStatus',
  setup(__props) {

const { currentCalculation } = useCurrentCalculation();
const { saveCalculation, isLoading } = useSaveCalculation();

function handleSaveCalculation() {
  if (!currentCalculation.value) return;

  saveCalculation(currentCalculation.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Message), {
    class: "bg-brand-50/25 text-brand-500 [&__.p-message-text]:w-full",
    severity: "primary"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, " Zmiany nie zostały jeszcze zapisane online. Naciśnij 'Zapisz', aby zapisać je w systemie. ", -1)),
        _createVNode(_unref(Button), {
          class: "ml-auto font-semibold",
          size: "small",
          disabled: _unref(isLoading),
          onClick: handleSaveCalculation
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Zapisz ")
          ])),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})